import * as Yup from "yup"
import { warranty } from "@components/Intl/messages/warranty"

export const schema = {
  nl: Yup.object().shape({
    firstName: Yup.string().required(`Voornaam ${warranty.nl.isRequired}`),
    lastName: Yup.string().required(`Achternaam ${warranty.nl.isRequired}`),
    email: Yup.string()
      .required(`Email ${warranty.nl.isRequired}`)
      .email(warranty.nl.emailError),
  }),
  en: Yup.object().shape({
    firstName: Yup.string().required(`First name ${warranty.en.isRequired}`),
    lastName: Yup.string().required(`Last name ${warranty.en.isRequired}`),
    email: Yup.string()
      .required(`Email ${warranty.en.isRequired}`)
      .email(warranty.en.emailError),
  }),
}
